import { ConsultPresenceMap, ConsultPresenceViewer } from './consult-presence.types';

export function getConsultViewers(
  consults: ConsultPresenceMap,
  consultCode: number | string,
): ConsultPresenceViewer[] {
  return consults[String(consultCode)] ?? [];
}

export function formatPresenceBadge(
  viewers: ConsultPresenceViewer[],
  currentUserId?: string,
): string | null {
  const others = currentUserId
    ? viewers.filter((v) => v.userId !== currentUserId)
    : viewers;

  if (others.length === 0) return null;

  if (others.length === 1) {
    return `${others[0].username}`;
  }

  return `${others.map((v) => v.username).join(', ')}`;
}
